<template>
  <div
    :class="[
      $style.base,
      {
        [$style.isMobile]: $screen === 's'
      }
    ]"
  >
    <div
      v-for="(item, idx) in items"
      :key="item"
      :class="$style.step"
    >
      <div
        :class="[
          $style.stepIcon,
          {
            [$style.completed]: stepsCompleted > idx,
            [$style.current]: stepsCompleted === idx
          }
        ]"
      >
        <BaseIcon
          v-if="stepsCompleted > idx"
          name="checkmark"
          size="s"
          color="inverted"
          v-test="'_completedEl'"
        />
        <BaseText
          v-if="stepsCompleted < idx + 1"
          :color="stepsCompleted === idx ? 'inverted' : 'default'"
          v-test="'_outstandingEl'"
        >
          {{ idx + 1 }}
        </BaseText>
      </div>
      <BaseText
        :color="stepsCompleted === idx ? 'default' : 'secondary'"
        :bold="stepsCompleted === idx"
      >
        {{ item }}
      </BaseText>
    </div>
  </div>
</template>

<script
  lang="ts"
  setup
>
defineProps<{
  stepsCompleted: number;
  items: string[];
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;

  &.isMobile {
    flex-wrap: wrap;

    .step {
      padding: $spacing * 0.5;
    }
  }
}

.step {
  display: flex;
  gap: $spacing * .5;
  margin-right: $spacing * 2;
}

.stepIcon {
  height: 20px;
  width: 20px;
  border-radius: 100%;
  background-color: var(--surface-secondary);

  &.completed {
    background-color: var(--success-base);
  }

  &.current {
    background-color: var(--action-primary);
  }

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
